import { Package } from 'lucide-react';

type OrderItemRowProps = {
  title: string;
  quantity?: number | null;
  image?: string | null;
};

export function OrderItemRow({ title, quantity, image }: OrderItemRowProps) {
  return (
    <div className="flex items-center gap-4">
      <div className="flex size-[60px] shrink-0 items-center justify-center rounded-lg bg-muted">
        {image ? (
          <img src={image} alt={title} className="size-full rounded-lg object-cover" />
        ) : (
          <Package className="size-6 text-muted-foreground" />
        )}
      </div>
      <div className="flex flex-col gap-0.5">
        <span className="text-sm font-medium">{title}</span>
        {quantity != null && <span className="text-sm text-muted-foreground">{quantity}ct</span>}
      </div>
    </div>
  );
}
